import { create } from 'zustand';
import type { User } from 'firebase/auth';
import type { Owner } from '@/types/owner';

type AuthState = {
  user: User | null;
  owner: Owner | null;
  loading: boolean;
  isAdmin: boolean;
  setUser: (user: User | null) => void;
  setOwner: (owner: Owner | null) => void;
  setLoading: (loading: boolean) => void;
  setIsAdmin: (isAdmin: boolean) => void;
  reset: () => void;
};

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  owner: null,
  loading: true,
  isAdmin: false,
  setUser: (user) => set({ user }),
  setOwner: (owner) => set({ owner }),
  setLoading: (loading) => set({ loading }),
  setIsAdmin: (isAdmin) => set({ isAdmin }),
  reset: () => set({ user: null, owner: null, isAdmin: false, loading: false }),
}));
